import React from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import { Delete, ContentCopy } from '@mui/icons-material';

export const RowActions: React.FC<{ onDelete: () => void; onDuplicate: () => void; }> = ({ onDelete, onDuplicate }) => {
  const handleDelete: React.MouseEventHandler = (e) => { e.stopPropagation(); onDelete(); };
  const handleDuplicate: React.MouseEventHandler = (e) => { e.stopPropagation(); onDuplicate(); };
  return (
    <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
      <Tooltip title="Delete">
        <IconButton size="small" color="error" onClick={handleDelete}>
          <Delete fontSize="small" />
        </IconButton>
      </Tooltip>
      <Tooltip title="Duplicate">
        <IconButton size="small" onClick={handleDuplicate}>
          <ContentCopy fontSize="small" />
        </IconButton>
      </Tooltip>
    </Box>
  );
};


